export default "__VITE_ASSET__3f3520ba__"